import { Box, Paper, Typography } from "@mui/material";
import { NotificationsNoneOutlined } from "@mui/icons-material";
import { Callout, NextStep, PageHeader } from "@components/ui_v2";

/**
 * Sala de espera de generación de contratos para Crédito Simple (`S_GenContratos` del diseño).
 * La pantalla no tiene CTA: el usuario avanza automáticamente cuando los contratos están listos.
 */
export const PreparandoContratosDefault = () => (
  <Box>
    <PageHeader
      eyebrow="Formalización · Generación de contratos"
      title="¡Tu crédito fue ratificado! Estamos preparando tus contratos"
      subtitle={
        <>
          Ya realizamos la <strong>ratificación crediticia, legal y de PLD</strong>. Ahora estamos preparando tus
          contratos; avanzarás automáticamente a la firma en cuanto estén listos.
        </>
      }
    />

    <Paper variant="lendia_paper" sx={{ p: "22px" }}>
      <Typography sx={{ fontSize: 17, fontWeight: 600, letterSpacing: "-0.015em", color: "primary.dark", mb: "4px" }}>
        Lo que sigue
      </Typography>
      <Typography sx={{ fontSize: 12.5, color: "tokens.textTertiary", lineHeight: 1.55, mb: "18px" }}>
        En este momento se están generando tus contratos.
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        <NextStep n={1} title="Revisión de condiciones" description="Validas las condiciones de tu crédito." />
        <NextStep n={2} title="Firma digital" description="Firmas tus contratos de forma digital." />
      </Box>

      <Box sx={{ mt: "18px" }}>
        <Callout tone="info" icon={<NotificationsNoneOutlined sx={{ fontSize: 14 }} />}>
          <strong>¡Despreocúpate!</strong> Puedes salir de esta pantalla. En cuanto tus contratos estén listos te
          contactaremos por <strong>correo y WhatsApp</strong> para que regreses a firmar.
        </Callout>
      </Box>
    </Paper>
  </Box>
);
